import { DEFAULT_TIME, MAX_VALID_DAYS } from "../../../constants/Constants";

export class BillingRuleEntity {
  id;
  ruleName;
  days;
  startTime;
  endTime;
  creationDate;
  siteId;
  billingRuleType;
  billingRuleToUserTypes;
  billingRuleRates;

  constructor(
    id,
    ruleName,
    siteId,
    billingRuleType,
    billingRuleToUserTypes,
    billingRuleRates = null,
    days = MAX_VALID_DAYS,
    startTime = DEFAULT_TIME,
    endTime = DEFAULT_TIME,
    creationDate,
    modifiedDate
  ) {
    this.id = id;
    this.ruleName = ruleName;
    this.siteId = siteId;
    this.billingRuleType = billingRuleType;
    this.billingRuleToUserTypes = billingRuleToUserTypes;
    this.days = days;
    this.startTime = startTime;
    this.endTime = endTime;
    this.creationDate = creationDate;
    this.modifiedDate = modifiedDate;
    this.billingRuleRates = billingRuleRates;
  }
}
